import React, { useEffect, useRef, useState } from 'react';

import '@toast-ui/editor/dist/toastui-editor.css';
import '@toast-ui/editor/dist/i18n/ko-kr';
import 'tui-color-picker/dist/tui-color-picker.css';
import '@toast-ui/editor-plugin-color-syntax/dist/toastui-editor-plugin-color-syntax.css';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'moment/locale/ko';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { useRecoilValue } from 'recoil';
import { authAtom } from '_state';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Dropzone from '../../components/Inputs/Dropzone';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { Autocomplete, Dialog, DialogActions, DialogContent, DialogTitle, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Popover } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import SunEditor from 'components/Editor/SunEditor';

const columns = [{ id: 'fileName', label: '첨부파일', minWidth: 40, width: 400, align: 'left' }];

export default function MailForward(props) {
  const editorRef = useRef();

  const [datas, setDatas] = useState({});
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    setError,
    formState: { errors, isDirty }
  } = useForm({});

  const auth = useRecoilValue(authAtom);

  const navigate = useNavigate();
  let formData = new FormData();

  const [open, setOpen] = useState(false);
  const [tmplItems, setTmplItems] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [content, setContent] = useState('');
  const [userEmailItems, setUserEmailItems] = useState([]);
  const [autoCompleteValue, setAutoCompleteValue] = useState([]);
  const [checked, setChecked] = useState([]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleChange = (e) => {
    setDatas({ ...datas, [e.target.id]: e.target.value });
  };

  const getEmailTemplate = async () => {
    const response = await axios.get(`/api/mail-template`);
    if (response) {
      setTmplItems(response.data);
    }
  };

  const handleApplyTemplate = (id) => async (e) => {
    const response = await axios.get(`/api/mail-template/${id}`);
    if (response) {
      const html = typeof response.data?.html === 'string' ? response.data?.html : response.data?.html.toString();
      setDatas(response.data);
      setContent(html);
    }
  };

  const handleDeleteTemplate = (id) => async (e) => {
    try {
      const response = await axios.delete(`/api/mail-template/${id}`);
      if (response) {
        getEmailTemplate();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const sendMail = async (formData, config) => {
    await axios
      .post(`/api/mail-send`, formData, config)
      .then((response) => {
        alert(response.data.message);
        navigate(`/mail`);
      })
      .catch((error) => {
        if (error?.message) {
          console.log(error.message);
        } else {
          alert(error.response.data.message);
        }
      });
  };

  /**
   * post 분할 전송 (서버 설정 불가능한 경우)
   * @param {*} data
   */
  const sendFormData = (data) => {
    const MAX_CHUNK_SIZE = 1024 * 512; // 0.5MB
    let offset = 0;
    while (offset < data.length) {
      const chunkSize = Math.min(MAX_CHUNK_SIZE, data.length - offset);
      const chunk = data.slice(offset, offset + chunkSize);
      formData.append('contents', chunk);
      offset += chunkSize;
    }
  };

  const onSubmit = async (data) => {
    if (autoCompleteValue.length <= 0 && checked.length <= 0) {
      alert('받는 사람을 입력해주세요.');
      return;
    }

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };
    formData.append('createdId', auth.userid);
    formData.append('recipient', JSON.stringify(autoCompleteValue));
    formData.append('subject', datas.subject);
    formData.append('checked', JSON.stringify(checked));
    formData.append('contents', editorRef?.current?.getContents());

    sendMail(formData, config);
  };

  const createTemplate = async (subject) => {
    const config = {
      headers: { 'content-type': 'multipart/form-data' }
    };
    formData.append('createdId', auth.userid);
    formData.append('recipient', datas.recipient);
    formData.append('subject', subject);
    formData.append('contents', editorRef?.current?.getContents());

    await axios
      .post(`/api/mail-template`, formData, config)
      .then((response) => {
        alert(response.data.message);
        setOpen(false);
        getEmailTemplate();
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const handleFileDelete = (fileId) => {
    axios
      .delete(`/api/board/file/${fileId}`)
      .then((response) => {
        alert(response.data.message);
        // axios.get(`/api/board/${kind}/${id}`).then((response) => {
        //   setDatas({ ...datas, files: response.data.files });
        // });
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeCheckbox = (e) => {
    const value = e.target.value;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const getUserEmail = async (value) => {
    const response = await axios.get(`/api/user-mail`, { recipient: datas?.value });
    if (response) {
      const result = response.data.rows.map((t) => {
        t.label = `${t.username} <${t.eMail}>`;
        t.value = `${t.eMail}`;
        return t;
      });
      setUserEmailItems(result);
    }
  };

  const handleChangeRecipient = (e) => {
    if (e.target.value.length >= 2) {
      getUserEmail(e.target.value);
    } else {
      setUserEmailItems([]);
    }
  };

  useEffect(() => {
    getEmailTemplate();
  }, []);

  return (
    <Paper sx={{ p: 4, display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex' }}>
        <Typography component="h2" variant="h6" color="primary" gutterBottom>
          알림 메일 전송
        </Typography>
        <Box sx={{ flex: '1 1 auto' }}></Box>
        <Button sx={{ width: 200, ml: 1 }} variant="contained" color="secondary" onClick={handleBack}>
          뒤로
        </Button>
      </Box>
      <Box sx={{ display: 'flex' }}>
        <Button sx={{ mx: 1 }} variant="contained" onClick={handleClick}>
          템플릿 <ArrowDropDownIcon sx={{ ml: 1 }} />
        </Button>
        <FormGroup row sx={{ ml: 2 }}>
          <FormControlLabel control={<Checkbox value="CHECK00" onChange={handleChangeCheckbox} checked={checked.includes('CHECK00')} />} name="checkedMailSend" label="내게 발송" />
          <FormControlLabel control={<Checkbox value="CHECK01" onChange={handleChangeCheckbox} checked={checked.includes('CHECK01')} />} name="checkedMailSend" label="수석 전체 발송" />
          <FormControlLabel control={<Checkbox value="CHECK02" onChange={handleChangeCheckbox} checked={checked.includes('CHECK02')} />} name="checkedMailSend" label="매니저 전체 발송" />
          <FormControlLabel control={<Checkbox value="CHECK03" onChange={handleChangeCheckbox} checked={checked.includes('CHECK03')} />} name="checkedMailSend" label="개인별" />
        </FormGroup>
      </Box>
      <Popover
        id={'template'}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <List dense={true}>
          {tmplItems.map((item, idx) => {
            return (
              <ListItem
                sx={{ p: 0 }}
                onClick={handleApplyTemplate(item.value)}
                secondaryAction={
                  <IconButton edge="end" aria-label="delete" onClick={handleDeleteTemplate(item.value)}>
                    <ClearIcon />
                  </IconButton>
                }
              >
                <ListItemButton>
                  <ListItemText primary={item.label} />
                </ListItemButton>
              </ListItem>
            );
          })}
          <Divider />
          <ListItem sx={{ p: 0 }} onClick={(e) => setOpen(true)}>
            <ListItemButton>
              <ListItemIcon>
                <AddIcon />
              </ListItemIcon>
              <ListItemText primary="입력한 내용을 템플릿으로 저장" />
            </ListItemButton>
          </ListItem>
        </List>
      </Popover>
      <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 2 }}>
        <Autocomplete
          freeSolo
          multiple
          id="recipient"
          options={userEmailItems}
          value={autoCompleteValue}
          onChange={(e, newval, reason) => {
            if (reason === 'createOption') {
              const value = newval[newval.length - 1];
              let newValue = { value: value, label: `${value} <${value}>`, username: value, eMail: value };
              setAutoCompleteValue([...autoCompleteValue, newValue]);
            } else {
              setAutoCompleteValue(newval);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="받는사람"
              placeholder="2자 이상 입력하세요."
              onChange={handleChangeRecipient}
              onKeyDown={(e) => {
                const value = e.target.value;
                if (e.code === 'enter' && value) {
                  setAutoCompleteValue(autoCompleteValue.concat(value));
                }
              }}
            />
          )}
        />
        {/* <TextField
          id="recipient"
          label="받는사람"
          fullWidth
          value={datas?.recipient || ''}
          error={!!errors.datas?.recipient}
          helperText={errors.datas?.recipient && errors.datas?.recipient.message}
          {...register('datas.recipient', {
            required: '받는사람을 입력해주세요.',
            maxLength: { value: 200, message: '받는사람은 200자 이하입니다.' }
          })}
          size="small"
          onChange={handleChange}
        /> */}
        <TextField
          id="subject"
          variant="outlined"
          label="제목"
          fullWidth
          value={datas?.subject || ''}
          error={!!errors.datas?.subject}
          helperText={errors.datas?.subject && errors.datas?.subject.message}
          size="small"
          sx={{ mt: 1 }}
          {...register('datas.subject', {
            required: '메일 제목을 입력해주세요.',
            onChange: (e) => handleChange(e)
          })}
        />
        <Box component="div" sx={{ minHeight: 400, my: 1, overflowY: 'auto' }}>
          <SunEditor
            ref={editorRef}
            lang="ko"
            defaultContents={content}
            setOptions={{
              height: 500
              // buttonList: [
              //   ['undo', 'redo'],
              //   ['font', 'fontSize', 'formatBlock'],
              //   ['paragraphStyle', 'blockquote'],
              //   ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
              //   ['fontColor', 'hiliteColor', 'textStyle'],
              //   ['removeFormat'],
              //   '/', // Line break
              //   ['outdent', 'indent'],
              //   ['align', 'horizontalRule', 'list', 'lineHeight'],
              //   ['table', 'link', 'image', 'video', 'audio' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.
              //   /** ['imageGallery'] */ // You must add the "imageGalleryUrl".
              //   ['fullScreen', 'showBlocks', 'codeView'],
              //   ['preview', 'print'],
              //   ['save', 'template']
              //   /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
              // ],
            }}
          />
        </Box>
        <br />
        <Box component="div" sx={{ maxWidth: 1200, ml: 1, overflowY: 'auto' }}>
          <Dropzone id="file" maxFilesize={5242880} formData={formData} />
        </Box>
        {!!datas.files && (
          <Box>
            <TableContainer component={'div'}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <>
                        <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth, width: column.width }}>
                          {column.label}
                        </TableCell>
                        <TableCell></TableCell>
                      </>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {datas.files.map((row, rowIdx) => (
                    <TableRow hover key={row.id}>
                      {columns.map((col, colIdx) => (
                        <>
                          <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                            {row[col.id]}
                          </TableCell>
                          <TableCell key={`row${rowIdx}-down`} align="left">
                            <Tooltip title={`파일 삭제`}>
                              <IconButton
                                aria-label="down"
                                onClick={(e) => {
                                  handleFileDelete(row.id);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
        <Button type="submit" sx={{ width: 200, ml: 1 }} variant="contained">
          전송
        </Button>
        <Button sx={{ width: 200, ml: 1 }} variant="contained" color="secondary" onClick={handleBack}>
          취소
        </Button>
      </Box>
      <TemplateSave open={open} pSubject={datas?.subject} handleClose={(e) => setOpen(false)} createTemplate={createTemplate} />
    </Paper>
  );
}

const TemplateSave = (props) => {
  const { open, pSubject, handleClose, createTemplate } = props;

  const [subject, setSubject] = useState(pSubject);

  const handleClickSave = (e) => {
    createTemplate(subject);
  };

  useEffect(() => {
    setSubject(pSubject);
  }, [pSubject]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xl" aria-labelledby="draggable-dialog-title">
      <DialogTitle>템플릿 저장</DialogTitle>
      <DialogContent>
        <TextField id="subject" variant="outlined" label="제목" fullWidth value={subject || ''} onChange={(e) => setSubject(e.target.value)} size="small" sx={{ mt: 1 }} />
        <Box sx={{ fontSize: 'small', p: 2, mt: 2, background: '#EAEAEA' }}>
          <Typography>메일쓰기에 입력한 내용을 템플릿으로 저장합니다.</Typography>
          <ul>
            <li>새 메일쓰기 화면에만 템플릿 기능이 제공됩니다.</li>
            <li>받는사람 및 파일은 템플릿에 저장되지 않습니다.</li>
          </ul>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleClickSave}>
          저장
        </Button>
        <Button variant="outlined" color="success" onClick={handleClose}>
          취소
        </Button>
      </DialogActions>
    </Dialog>
  );
};
